import axios from 'axios'

/**
 * API for getting list of workspace
 */
export const getListOfWorkspace = async () => {
  const response = await axios.get(`workspaces`)
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const createOrUpdateWorkspace = async (payload) => {
  let response
  if (payload?.id) {
    const id = payload.id
    delete payload.id

    response = await axios.put(`workspaces/${id}`, payload)
  } else {
    response = await axios.post('workspaces', payload)
  }

  return response
}

/**
 *
 * @param {string} workspaceId
 * @param {boolean} notAdded
 * @returns
 */
export const getUsersofWorkspace = async (workspaceId, notAdded = true) => {
  let response
  if (notAdded) {
    response = await axios.get(
      `workspaces/eligible-users?workspaceId=${workspaceId}`
    )
  } else {
    response = await axios.get(`workspaces/users?workspaceId=${workspaceId}`)
  }
  return response
}

export const addOrRemoveUsersFromWorkspace = async (payload, isAdd = true) => {
  let response
  if (isAdd) {
    response = await axios.put(`workspaces/users`, payload)
  } else {
    response = await axios.delete('workspaces/users', { data: payload })
  }
  return response
}
